import {
  Button,
  createMuiTheme,
  InputLabel,
  MuiThemeProvider,
  TextField,
  Tooltip, Dialog, DialogActions, DialogContent, DialogTitle
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  getCountries
} from "../../../../api/country";
import {
  deleteCustomer,
  getCustomerById,
  postCustomer,
  updateCustomer
} from "../../../../api/customer";
import {
  getLocalidades
} from "../../../../api/localidad";
import { getProvincias } from "../../../../api/provincia";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";

import { Delete, Visibility } from "@material-ui/icons";
import { SERVER_URL } from "../../../../api";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import FilePickerDialog from "../../../components/dialogs/FilePickerDialog";
import { buttonsStyle } from "../../../components/tables/table";
import EditIcon from "@material-ui/icons/Edit";
import { shallowEqual, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import Editor from '../../../components/editor/Editor'
import { getNonEmpty } from '../../../../utils/helpers'

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyBusinessArea() {
  return {
    title: {
      'es': "",
      'en': ""
    },
    description: {
      'es': "",
      'en': ""
    },
    order: -1
  }
}

function getEmptyCustomer(role) {
  return {
    fullName: "",
    nif: "",
    address: "",
    zipCode: null,
    email: "",
    phoneNumber: null,
    role: [role],
    country: "",
    province: "",
    city: "",
    VAT: "",
    okKYB: false,
    userCustomer: [],
    logoURL: "",
    website: "",
    linkedIn: "",
    documents: [],
    customerDescription: "",
    credentials: "",
    businessArea: [],
    advisorService: [],
    active: true,
  }
}

function getEmptySelected() {
  return {
    _id: ""
  }
}

function logoSection(selectedLogo, setSelectedLogo, customer, setCustomer, openPreviewDialog, setOpenPreviewDialog) {
  return (
    <div className="mt-2">
      <InputLabel>Logo</InputLabel>
      <label htmlFor={"upload-media"} className="ml-0 mb-4 mt-1" >
        <input
          style={{ display: "none" }}
          id={"upload-media"}
          name={"upload-media"}
          type="file"
          accept={"image/*"}
          onChange={(e) => {
            setSelectedLogo(e.target.files[0]);
          }}
        />
        <Button
          style={{ marginRight: "15px" }}
          color="secondary"
          component="span"
          variant="outlined"
        >
          {selectedLogo ||
            (customer.logoURL && customer.logoURL !== "")
            ? "Change media"
            : "Upload media"}
        </Button>
      </label>
      {(selectedLogo ||
        (customer.logoURL && customer.logoURL !== "")) && (
          <>
            <Tooltip title={"Preview"}>
              <Button
                size="small"
                onClick={() => setOpenPreviewDialog(true)}
                style={{
                  ...buttonsStyle,
                  marginRight: "15px",
                }}
              >
                <Visibility />
              </Button>
            </Tooltip>
            <PreviewDialog
              title={"Preview"}
              open={openPreviewDialog}
              setOpen={setOpenPreviewDialog}
              file={selectedLogo}
              src={
                selectedLogo
                  ? URL.createObjectURL(selectedLogo)
                  : `${SERVER_URL}/${customer.logoURL}`
              }
            />
            <Tooltip title={"Delete"}>
              <Button
                size="small"
                onClick={() => {
                  setSelectedLogo(null);
                  setCustomer({
                    ...customer,
                    logoURL: null,
                  });
                }}
              >
                <Delete />
              </Button>
            </Tooltip>
          </>
        )}
    </div>
  );
}

function documentsUpload(selectedDocuments, setSelectedDocuments, customer, setCustomer, openFileDialog, setOpenFileDialog) {
  return (
    <div className="mt-2">
      <InputLabel>Documents</InputLabel>
      <label htmlFor={"upload-documents"} className="ml-0 mb-4 mt-1" >
        <input
          style={{ display: "none" }}
          id={"upload-documents"}
          name={"upload-documents"}
          type="file"
          accept=".pdf,application/pdf"
          multiple
          onChange={(e) => {
            setSelectedDocuments([...e.target.files]);
          }}
        />
        <Button
          style={{ marginRight: "15px" }}
          color="secondary"
          component="span"
          variant="outlined"
        >
          {selectedDocuments.length > 0 ||
            (customer.documents && customer.documents.length > 0)
            ? "Change media"
            : "Upload media"}
        </Button>
      </label>
      {(selectedDocuments.length > 0 ||
        (customer.documents && customer.documents.length > 0)) && (
          <>
            <Tooltip title={"Preview"}>
              <Button
                size="small"
                onClick={() => setOpenFileDialog(true)}
                style={{
                  ...buttonsStyle,
                  marginRight: "15px",
                }}
              >
                <Visibility />
              </Button>
            </Tooltip>

            <FilePickerDialog
              title={"Archivos"}
              open={openFileDialog}
              setOpen={setOpenFileDialog}
              data={selectedDocuments}
              editable={false}
            />
            <Tooltip title={"Delete"}>
              <Button
                size="small"
                onClick={() => {
                  setSelectedDocuments([]);
                  setCustomer({
                    ...customer,
                    documents: [],
                  });
                }}
              >
                <Delete />
              </Button>
            </Tooltip>
          </>
        )}
    </div>
  );
}

export function NewTable({ data, columns, ...tableProps }) {
  const rowClasses = row => (row.active === false ? "inactive-row" : "");
  return (
    <ToolkitProvider
      bootstrap4
      keyField='id'
      data={data}
      columns={columns}
      search
    >
      {props => (
        <div>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bordered={false}
            striped
            rowClasses={rowClasses}
            {...tableProps}
            {...props.baseProps}
          />
        </div>
      )}
    </ToolkitProvider>
  )
}

function businessAreaDialog(businessOpen, setBuisnessOpen, businessSelected, setBusinessSelected, businessData, setBusinessData, setTableKey) {

  const dialogTitle = businessSelected.order < 0 ? "Create business area" : "Edit business area"


  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === ' ')
        return
      if (!businessSelected[element])
        businessSelected[element] = {}
      let newText = businessSelected[element]
      newText[lang] = event.target.value
      setBusinessSelected({ ...businessSelected, [element]: newText })
    } else
      setBusinessSelected({ ...businessSelected, [element]: event.target.value })
  }

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === ' ')
        return
      if (!businessSelected[element])
        businessSelected[element] = {}
      let newText = businessSelected[element]
      newText[lang] = value
      setBusinessSelected({ ...businessSelected, [element]: newText })
    } else
      setBusinessSelected({ ...businessSelected, [element]: value })
  }

  const renderMultilanguageTabContent = lang => {
    return (
      <>
        <TextField
          label="Title"
          value={(businessSelected.title && businessSelected.title[lang]) || ''}
          onChange={handleChange('title', lang)}
          margin="normal"
          variant="outlined"
          required
        />
        <Editor
          body={(businessSelected.description && businessSelected.description[lang]) || ''}
          setBody={new_body => handleChangeEditor('description', lang, new_body)}
          className='max-height'
          lang={lang}
          placeholder={'Enter company description here...'}
        />
      </>
    )
  }

  return (
    <Dialog
      open={businessOpen}
      onClose={() => setBuisnessOpen(false)}
      aria-labelledby="confirm-dialog">
      <DialogTitle id="confirm-dialog">{dialogTitle}</DialogTitle>
      <DialogContent style={{ overflowX: 'hidden' }}>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            if (!businessSelected.title?.es || businessSelected.title?.es.trim() === '') {
              alertError({ customMessage: "Spanish title is required." });
              return;
            }

            if (businessSelected.title?.en === '' || businessSelected.title?.en === '') {
              alertError({ customMessage: "English title is required." });
              return;
            }

            if (dialogTitle.includes("Create")) {
              const lastOrder = businessData.reduce((max, item) => Math.max(max, item.order || 0), 0);
              const newBusiness = {
                ...businessSelected,
                order: lastOrder + 1,
              };

              setBusinessData([...businessData, newBusiness]);
            } else {
              const updatedData = businessData.map((item, index) =>
                index === businessSelected.order - 1 ? businessSelected : item
              );
              setBusinessData([...updatedData]);
            }

            setTableKey(k => k + 1);
            setBusinessSelected(getEmptyBusinessArea())
            setBuisnessOpen(false)
          }}
        >
          Save
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            setBuisnessOpen(false)
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const DefaultTextField = ({ label, value, onChange, required = true, ...props }) => {

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      margin="normal"
      variant="outlined"
      required={required}
      {...props}
    />
  );
};

export default function EditCustomerPage() {
  const customerId = useParams().id;
  const history = useHistory();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton
  } = useSkeleton();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const rolePathSingle = useLocation().pathname.split("/")[1].replace("edit-", "");
  const rolePathUpperCase = rolePathSingle.charAt(0).toUpperCase() + rolePathSingle.slice(1);
  const rolePath = rolePathSingle + 's';

  const [customer, setCustomer] = useState(getEmptyCustomer(rolePathSingle));
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [provinces, setProvinces] = useState([]);

  const [selectedCountry, setselectedCountry] = useState(getEmptySelected())
  const [selectedProvince, setselectedProvince] = useState(getEmptySelected())

  const [selectedLogo, setSelectedLogo] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(null);

  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [openFileDialog, setOpenFileDialog] = useState(false);

  const [businessOpen, setBuisnessOpen] = useState(false);
  const [businessSelected, setBusinessSelected] = useState(getEmptyBusinessArea())
  const [businessData, setBusinessData] = useState([])

  const [openConfirmDeleteBusiness, setOpenConfirmDeleteBusiness] = useState(false);
  const [businessOrder, setBusinessOrder] = useState(null)

  const [tableKey, setTableKey] = useState(0);


  useEffect(() => {
    getCountries()
      .then((res) => { setCountries(res.data) })
      .catch((error) => { alertError({ error: error, customMessage: "Could not get countries." }); })

    getLocalidades()
      .then((res) => { setCities(res.data) })
      .catch((error) => { alertError({ error: error, customMessage: "Could not get cities." }); })

    getProvincias()
      .then((res) => { setProvinces(res.data) })
      .catch((error) => { alertError({ error: error, customMessage: "Could not get provinces." }); })


    if (!customerId) {
      disableLoadingData();
      return;
    }

    getCustomerById(customerId)
      .then((res) => {
        setCustomer(res.data);
        setselectedCountry(res.data.country)
        setselectedProvince(res.data.province)
        setBusinessData(res.data.businessArea)
        setSelectedDocuments(res.data.documents)
        disableLoadingData();
      })
      .catch((error) => {
        alertError({ error: error, customMessage: `Could not get ${rolePathSingle}` });
        history.push(`/${rolePath}`);
      });
  }, [customerId, disableLoadingData, history, rolePath, rolePathSingle]);


  function saveCustomer() {
    customer.businessArea = businessData
    if (!customerId) {
      postCustomer(customer, selectedLogo, selectedDocuments)
        .then((res) => {
          alertSuccess({ title: "Saved!", customMessage: `${rolePathUpperCase} successfully created.` });
          history.push(`/${rolePath}`);
        })
        .catch((error) => {
          alertError({ error: error, customMessage: `Could not save ${rolePathSingle}` });
        });
    } else {
      updateCustomer(customerId, customer, selectedLogo, selectedDocuments)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push(`/${rolePath}`);
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  function buttonFormatter(cell) {
    const elem = businessData.find((item) => item.order === cell);

    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setBusinessSelected(elem)
              setBuisnessOpen(true)
            }
            }
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setOpenConfirmDeleteBusiness(true)
                  setBusinessOrder(elem.order)
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "title", text: "Title", formatter: (cell, row) => getNonEmpty(row.title) },
    { dataField: "order", text: "", formatter: buttonFormatter, headerStyle: { width: '150px' } },
  ];

  const handleChange = (field) => (event) => {
    setCustomer({ ...customer, [field]: event.target.value });
  };

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title={`Edit ${rolePathUpperCase}`} />
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-4">
              <DefaultTextField label={"Company name"} value={customer.fullName} onChange={handleChange("fullName")} />
            </div>
            <div className="col-4">
              <DefaultTextField label={"NIF"} value={customer.nif} onChange={handleChange("nif")} />
            </div>
            <div className="col-4">
              <DefaultTextField label={"VAT"} value={customer.VAT} onChange={handleChange("VAT")} />
            </div>
          </div>
          <div className="d-flex align-item-center">
            <div className="col-4">
              <DefaultTextField label={"Contact Email"} value={customer.email} onChange={handleChange("email")} />
            </div>
            <div className="col-2">
              <DefaultTextField label={"Phone number"} value={customer.phoneNumber} onChange={handleChange("phoneNumber")} type="number" />
            </div>
            <div className="col-3">
              <DefaultTextField label={"Website"} value={customer.website} onChange={handleChange("website")} required={false} type="url" />
            </div>
            <div className="col-3">
              <DefaultTextField label={"LinkedIn"} value={customer.linkedIn} onChange={handleChange("linkedIn")} required={false} type="url" />
            </div>
          </div>

          <div className="d-flex align-item-center">
            <div className="col-4">
              <DefaultTextField label={"Credentials"} value={customer.credentials} onChange={handleChange("credentials")} required={false} />
            </div>
            <div className="col-4">
              {logoSection(selectedLogo, setSelectedLogo, customer, setCustomer, openPreviewDialog, setOpenPreviewDialog)}
            </div>
            <div className="col-4">
              {documentsUpload(selectedDocuments, setSelectedDocuments, customer, setCustomer, openFileDialog, setOpenFileDialog)}
            </div>
          </div>

          <div className="d-flex align-item-center">
            <div className="col-6">
              <DefaultTextField
                label={"Company descrption"}
                value={customer.customerDescription}
                onChange={(e) =>
                  setCustomer(prev => ({ ...prev, customerDescription: e.target.value }))
                }
                required={false}
                multiline
                minRows={3}
                maxRows={5}
                inputProps={{
                  style: {
                    overflowY: 'auto',
                  },
                }}
              />
            </div>
            {rolePathSingle === 'advisor' && (
              <>
                <div>
                </div>
              </>
            )
            }

          </div>


          <div className="d-flex justify-content-end col-12">
            <button
              type="button"
              className="btn btn-primary text-white"
              onClick={() => {
                setBuisnessOpen(true)
              }}
            >
              Add new
            </button>
          </div>

          <div className="col-12 mb-2">
            <NewTable key={tableKey} data={businessData} columns={columns} />
          </div>

          <div className="d-flex align-item-center">
            <div className="col-12 col-lg-4">
              <Autocomplete
                id='Countries'
                options={countries}
                value={customer.country || null}
                getOptionLabel={(option) => option.name}
                onChange={(_, newValue) => {
                  if (!newValue)
                    setselectedCountry(getEmptySelected());
                  else
                    setselectedCountry(newValue);
                  setCustomer({
                    ...customer,
                    country: newValue,
                    province: "",
                    city: ""
                  })
                  setselectedProvince(getEmptySelected())
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Country'
                    margin="normal"
                    variant="outlined"
                  />
                )}
                required
              />
            </div>
            <div className="col-12 col-lg-4">
              <Autocomplete
                id='Provinces'
                options={provinces.filter(item => item.pais === selectedCountry._id)}
                value={customer.province || null}
                getOptionLabel={(option) => option.fullName}
                onChange={(_, newValue) => {
                  if (!newValue)
                    setselectedProvince(getEmptySelected());
                  else
                    setselectedProvince(newValue);
                  setCustomer({
                    ...customer,
                    province: newValue,
                    city: ""
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Province'
                    margin="normal"
                    variant="outlined"
                  />
                )}
                disabled={selectedCountry._id === ""}
                required
              />
            </div>
            <div className="col-12 col-lg-4">
              <Autocomplete
                id='Cities'
                options={cities.filter(item => item.provincia === selectedProvince._id)}
                value={customer.city || null}
                getOptionLabel={(option) => option.fullName}
                onChange={(_, newValue) => {
                  setCustomer({
                    ...customer,
                    city: newValue
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='City'
                    margin="normal"
                    variant="outlined"
                  />
                )}
                disabled={selectedProvince._id === ""}
                required
              />
            </div>
          </div>

          <div className="d-flex align-item-center">
            <div className="col-4">
              <DefaultTextField label={"Address"} value={customer.address} onChange={handleChange("address")} />
            </div>
            <div className="col-2">
              <DefaultTextField label={"Zip code"} value={customer.zipCode} onChange={handleChange("zipCode")} required={false} type="number" />
            </div>
          </div>
        </CardBody>
      </Card >

      <Button
        onClick={() => history.push(`/${rolePath}`)}
        variant="outlined"
        style={{ marginRight: 20 }}
      >
        Back
      </Button>
      <Button
        onClick={() => saveCustomer()}
        variant="outlined"
        color="primary"
        style={{ marginRight: 20 }}
      >
        Save {rolePathUpperCase}
      </Button>

      {businessAreaDialog(businessOpen, setBuisnessOpen, businessSelected, setBusinessSelected, businessData, setBusinessData, setTableKey)}

      <ConfirmDialog
        title={"Are you sure you want to delete this business area?"}
        open={openConfirmDeleteBusiness}
        setOpen={setOpenConfirmDeleteBusiness}
        onConfirm={() => {
          const updatedData = businessData
            .filter(item => item.order !== businessOrder)
            .map((item, index) => ({
              ...item,
              order: index + 1,
            }));
          setBusinessData([...updatedData]);
          setTableKey(k => k + 1);

          alertSuccess({
            title: "Deleted!",
            customMessage: "Business area deleted successfully.",
          });
        }}
      />

      {
        customerId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
              >
                Delete {rolePathUpperCase}
              </Button>
            </MuiThemeProvider>

            <ConfirmDialog
              title={`Are you sure you want to delete this ${rolePathSingle}?`}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteCustomer(customerId)
                  .then((res) => {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: `${rolePathUpperCase} deleted successfully`,
                    });
                    history.push(`/${rolePath}`);
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: `Could not delete ${rolePathSingle}`,
                    });
                  });
              }}
            />
          </>
        )
      }
    </>
  );
}
